import {
  format,
  setHours,
  setMilliseconds,
  setMinutes,
  setSeconds,
} from 'date-fns';
import * as locales from 'date-fns/locale';
import { utcToZonedTime } from 'date-fns-tz';

const currentYear = new Date().getFullYear();
const getLocalTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const getUtcToLocalZonedTime = (date: Date | string) =>
  utcToZonedTime(date, getLocalTimeZone());
interface ILocalizedDateProps {
  date?: string | null | Date;
  locale?: string;
  formatDate?: string;
}
const getLocalizedDate = ({
  date,
  locale,
  formatDate = 'd MMMM yyyy',
}: ILocalizedDateProps) =>
  date
    ? format(new Date(date || ''), formatDate, {
        locale: locales[locale as keyof typeof locales],
      })
    : '';

const setExactHour = (hour: number) => {
  return setMilliseconds(
    setSeconds(setMinutes(setHours(new Date(), hour), 0), 0),
    0
  );
};

const clearSecondsAndMilliseconds = (date: Date) =>
  setMilliseconds(setSeconds(date, 0), 0);

export {
  clearSecondsAndMilliseconds,
  currentYear,
  getLocalizedDate,
  getLocalTimeZone,
  getUtcToLocalZonedTime,
  setExactHour,
};
